const variables = {
    place: [
        { value: 'fjøra',   label: 'Fjøra' },
        { value: 'dalen',   label: 'Dalen' },
        { value: 'norane',  label: 'Norane' }
    ],
    gender: [
        { value: 'kvinne',  label: 'Kvinne' },
        { value: 'mann',    label: 'Mann' },
    ],
    age: [
        { value: 'Ungdom 13 - 25',      label: 'Ungdom 13 - 25' },
        { value: 'Ung 26 - 40',         label: 'Ung 26 - 40' },
        { value: 'Middelaldra 41 - 60', label: 'Middelaldra 41 - 60' },
        { value: 'Eldre 61 -',          label: 'Eldre 61 -' },
    ],
    date_of_recording: [
        { value: '1996',       label: '1996' },
        { value: '2001',       label: '2001' },
        { value: '2016',       label: '2016' },
        { value: '2017',       label: '2017' },
    ],
    education: [
        { value: 'grunnskule',   label: 'Grunnskule' },
        { value: 'vidaregåande', label: 'Vidaregåande' },
        { value: 'høgskule',     label: 'Høgskule' },
        { value: 'yrkesfag',     label: 'Yrkesfag' }
    ],
    occupation: [
        { value: 'elev',        label: 'Elev' },
        { value: 'primær',      label: 'Primær' },
        { value: 'sekundær',    label: 'Sekundær' },
        { value: 'tertiær',     label: 'Tertiær' }
    ],
    parents_background: [
        { value: 'ingen',   label: 'Ingen frå Sogndal' },
        { value: 'mor',     label: 'Mor frå Sogndal' },
        { value: 'far',     label: 'Far frå Sogndal' },
        { value: 'begge',   label: 'Begge frå Sogndal' }
    ],
    birth: [
        { value: '1911',       label: '1911 - 1940' },
        { value: '1941',       label: '1941 - 1970' },
        { value: '1971',       label: '1971 - 2000' },
        { value: '2001',       label: '2001 -' }
    ],
    panel: [
        { value: 'panel',     label: 'Panel' },
        { value: 'trend',     label: 'Trend' }
    ]
};

export default variables;